/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: BCC Pubs
    Author: Johnny Palmer
  Author URL: http://sweetas.xyz
==========================================================================================*/

export default {
  products: [],
  sites:[],
  details: {
    id:'',
    refid:'',
    company:'',
    address1:'',
    address2:'',
    address3:'',
    town:'',
    country:'',
    countrySC:'',
    postcode:'',
    region:'',
    deliveryCompany:'',
    deliveryAddress1:'',
    deliveryAddress2:'',
    deliveryAddress3:'',
    deliveryTown:'',
    deliveryCountry:'',
    deliveryCountrySC:'',
    deliveryPostcode:'',
    deliveryRegion:'',   
    ipaddress:''
  },
  volunteer: {
    title: '',
    firstname:'',
    lastname:'',
    email:'',
    telephone:'',
    mobile:'',
    vaddress1:'',
    vaddress2:'',
    vaddress3:'',
    vtown:'',
    vcountry:'',
    vcountrySC:'',
    vpostcode:'',
  }
}